import type { FC } from 'react';
import { useIsNewDesignActive } from 'src/pages/new-design/is-new-design';
import { cn } from 'src/utils/cn';

export const CheckedIcon: FC<{
  error?: boolean;
  disabled?: boolean;
}> = ({ error, disabled }) => {
  const isNewDesignActive = useIsNewDesignActive();

  const errorColor = isNewDesignActive
    ? 'var(--color-border-support-error-subdued)'
    : 'var(--color-legacy-error)';
  const disabledColor = isNewDesignActive
    ? 'var(--color-border-surface-disabled)'
    : 'var(--color-legacy-inactive)';
  const disabledBgColor = isNewDesignActive
    ? 'var(--color-background-surface-disabled)'
    : 'var(--color-legacy-inactive-lighter)';
  const regularColor = isNewDesignActive
    ? 'var(--color-border-surface-default)'
    : 'var(--color-legacy-brand)';

  const primaryColor = disabled
    ? disabledColor
    : error
      ? errorColor
      : regularColor;
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 14 14"
      className={cn(disabled ? 'cursor-not-allowed' : 'cursor-pointer')}
    >
      <rect
        x="0.5"
        y="0.5"
        width="13"
        height="13"
        rx="2.5"
        fill={primaryColor}
        stroke={primaryColor}
        strokeWidth="1"
      />
      <path
        d="M3 6.5 L6.045 9.545 L11.065 4.525"
        fill="none"
        stroke={disabled ? disabledBgColor : '#fff'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UncheckedIcon: FC<{
  error?: boolean;
  disabled?: boolean;
}> = ({ error, disabled }) => {
  const isNewDesignActive = useIsNewDesignActive();

  const errorColor = isNewDesignActive
    ? 'var(--color-border-support-error-subdued)'
    : 'var(--color-legacy-error)';
  const errorBgColor = isNewDesignActive
    ? 'var(--color-background-support-error-minimal)'
    : 'var(--color-legacy-error-lighter)';
  const disabledColor = isNewDesignActive
    ? 'var(--color-border-surface-disabled)'
    : 'var(--color-legacy-inactive)';
  const disabledBgColor = isNewDesignActive
    ? 'var(--color-background-surface-disabled)'
    : 'var(--color-legacy-inactive-lighter)';
  const regularColor = isNewDesignActive
    ? 'var(--color-border-surface-default)'
    : 'var(--color-legacy-brand)';

  const primaryColor = disabled
    ? disabledColor
    : error
      ? errorColor
      : regularColor;
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 14 14"
      className={cn(disabled ? 'cursor-not-allowed' : 'cursor-pointer')}
    >
      <rect
        x="0.5"
        y="0.5"
        width="13"
        height="13"
        rx="2.5"
        fill={disabled ? disabledBgColor : error ? errorBgColor : '#fff'}
        stroke={primaryColor}
        strokeWidth="1"
      />
    </svg>
  );
};

export const MixedCheck: FC<{
  error?: boolean;
  disabled?: boolean;
}> = ({ error, disabled }) => {
  const isNewDesignActive = useIsNewDesignActive();

  const errorColor = isNewDesignActive
    ? 'var(--color-border-support-error-subdued)'
    : 'var(--color-legacy-error)';
  const disabledColor = isNewDesignActive
    ? 'var(--color-border-surface-disabled)'
    : 'var(--color-legacy-inactive)';
  const regularColor = isNewDesignActive
    ? 'var(--color-border-surface-default)'
    : 'var(--color-legacy-brand)';

  const primaryColor = disabled
    ? disabledColor
    : error
      ? errorColor
      : regularColor;
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 14 14"
      className={cn(disabled ? 'cursor-not-allowed' : 'cursor-pointer')}
    >
      <rect
        x="0.5"
        y="0.5"
        width="13"
        height="13"
        rx="2.5"
        fill={primaryColor}
        stroke={primaryColor}
        strokeWidth="1"
      />
      <path
        d="M3.319 6.934 H11.061"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
